module.exports = __webpack_public_path__ + "media/images/pc/top/header-bg-a92487fd87e985ee00c1afb60b230513.png";